import dayjs from 'dayjs';

export const getDateDifference = (
  startDate: string,
  endDate: string | null
) => {
  const start = dayjs(startDate);
  const end = endDate === null ? dayjs() : dayjs(endDate);

  const years = end.diff(start, 'year');
  const months = end.diff(start, 'month') % 12;
  const days = end.diff(start, 'day') % 30;

  const parts = [];
  if (years > 0) parts.push(`${years} ${years === 1 ? 'year' : 'years'}`);
  if (months > 0) parts.push(`${months} ${months === 1 ? 'month' : 'months'}`);
  if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);

  return parts.join(' ');
};
